/**
 * Check if arg is an array
 *
 * @param {any} arg
 * @return {Boolean}
 */
export const isArray = (arg) => {
    if (!Array.isArray) {
        Array.isArray = function(arg) {
            return Object.prototype.toString.call(arg) === '[object Array]';
        };
    }

    return Array.isArray(arg);
};



// WEBPACK FOOTER //
// ./helpers/Polyfills.js